import { render, staticRenderFns } from "./ProcessoDatasForm.vue?vue&type=template&id=4b7f7085&scoped=true"
import script from "./ProcessoDatasForm.vue?vue&type=script&lang=js"
export * from "./ProcessoDatasForm.vue?vue&type=script&lang=js"
import style0 from "./ProcessoDatasForm.vue?vue&type=style&index=0&id=4b7f7085&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b7f7085",
  null
  
)

export default component.exports